import { setFatalError } from '../../FatalError/FatalError'
import { isSupportedBrowser } from '../../global/browser'

declare global {
  interface Window {
    webkitRTCPeerConnection: typeof RTCPeerConnection
  }
}

const ensureBrowserSupport = () => {
  /** Confirm browser is one of Chrome/Chromium/Firefox/Safari (or Blink-based) */
  if (!isSupportedBrowser()) {
    setFatalError('BROWSER_NOT_SUPPORTED')
    return false
  }

  /** WebRTC tech check */
  if (!window.webkitRTCPeerConnection && !window.RTCPeerConnection) {
    setFatalError('BROWSER_WEBRTC_NOT_SUPPORTED')
    return false
  }

  return true
}

export { ensureBrowserSupport }
